export const EVENTS = [
  {
    id: 1,
    code: 'event_1',
    title: 'Cérémonie de clôture de CaVALIÉ 10e édition',
    shortDescription: 'CaVALIÉ (Camp des Vacances des Activités Ludiques et Intellectuelles des Élèves) est un programme dédié aux écoliers et élèves pendant les grandes vacances scolaires (juin à septembre).',
    description: '<b>CaVALIÉ</b> (Camp des Vacances des Activités Ludiques et Intellectuelles des Élèves) est un programme dédié aux écoliers et élèves pendant les grandes vacances scolaires (juin à septembre). Ce programme offre dans un cadre sécurisé, approprié et dans une ambiance bonne enfance, les cours de renforcement de capacité dans certaines disciplines avec une approche pédagogique adéquate et un programme de coaching scolaire qui tiennent compte du contexte et des difficultés des élèves participants. De nombreux jeux de société et des ateliers de pratiques sont organisés pour permettre aux participants de s\'approprier les concepts étudiés. À chaque édition du CaVALIÉ, nous travaillons à motiver les participants afin qu\'ils poursuivent pendant l\'année scolaire les efforts pour une réussite éclatante. De nombreuses récompenses ont été offertes aux participants pour célébrer leur volonté, leur discipline au travail, leur engagement … lors de la cérémonie de clôture comme en témoignent les images des 9e et 10e édition.',
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: 'La 11e édition du CaVALIÉ commence le lundi 19 juin 2023 à 8 heures précises.',
    nextEventDate: '19 Juin 2023',
    nextEventHour: '8:00',
    mainBanner: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/1_ceremonie_cloture_CaVALIE10e_edition.jpg',
    galleria: [
      {
        src: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/img/1.jpg',
        caption: 'ceremonie_cloture_CaVALIE10e_edition_1',
        thumb: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/img/1.jpg'
      },
      {
        src: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/img/2.jpg',
        caption: 'ceremonie_cloture_CaVALIE10e_edition_2',
        thumb: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/img/2.jpg'
      },
      {
        src: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/img/3.jpg',
        caption: 'ceremonie_cloture_CaVALIE10e_edition_3',
        thumb: 'assets/images/events/1_ceremonie_cloture_CaVALIE10e_edition/img/3.jpg'
      }
    ]
  },
  {
    id: 2,
    code: 'event_2',
    title: 'La traditionnelle coupure du gâteau du succès',
    shortDescription: 'Les candidats au Baccalauréat session de juin 2022, participant à la 9è édition du programme de renforcement de capacité avaient sacrifié à la tradition de coupure du gâteau du succès le jeudi 16 juin 2022.',
    description: `Les candidats au Baccalauréat session de juin 2022, participant à la 9è édition du programme de renforcement de capacité avaient sacrifié à la tradition de <b>coupure du gâteau du succès</b> le jeudi 16 juin 2022. Cette cérémonie célèbre au <b>C.A.C.E Ste Louise de Siméon</b>  en anticipé les mérites des participants au programme notamment ceux en classes d\'examen (terminales et troisième), ceux des premières scientifiques et techniques. C\'est aussi une marque de confiance car nous sommes conscients au <b>C.A.C.E</b> que le travail constant accompli dans la discipline et la rigueur porte de merveilleux fruits et les résultats dudit programme l\'ont toujours témoigné. <br/>
    La dixième édition du programme se poursuit actuellement avec des révisions intensives au profit des candidats aux examens nationaux. Rendez-vous le jeudi 15 juin 2023 pour la prochaine coupure du gâteau du succès. <b>Yes !</b>`,
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '15 Juin 2023',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/2 _traditionnelle_coupure_gateau_succes.jpeg',
    galleria: [
      {
        src: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/1.jpeg',
        caption: 'coupure_gateau_succes_1',
        thumb: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/1.jpeg'
      },
      {
        src: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/2.jpeg',
        caption: 'coupure_gateau_succes_2',
        thumb: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/2.jpeg'
      },
      {
        src: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/3.jpeg',
        caption: 'coupure_gateau_succes_3',
        thumb: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/3.jpeg'
      },
      {
        src: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/4.jpeg',
        caption: 'coupure_gateau_succes_4',
        thumb: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/4.jpeg'
      },
      {
        src: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/5.jpeg',
        caption: 'coupure_gateau_succes_5',
        thumb: 'assets/images/events/2 _traditionnelle_coupure_gateau_succes/img/5.jpeg'
      }
    ]
  },
  {
    id: 3,
    code: 'event_3',
    title: 'Préparation de la rentrée scolaire 2022-2023',
    shortDescription: 'À l\'orée de chaque rentrée scolaire, le C.A.C.E organise des séances de sensibilisation pour contribuer à l\'effort de tous les acteurs du système scolaire.',
    description: 'À l\'orée de chaque rentrée scolaire, le C.A.C.E organise des séances de sensibilisation pour contribuer à l\'effort de tous les acteurs du système scolaire. C\'est dans ce cadre que des séances de coaching sont organisées à l\'intention pour susciter une motivation intrinsèque au niveau de chaque apprenant, éveiller en chacun d\'eux le potentiel qui sommeille et faire découvrir à chacun d\'eux ce qu\'ils ont d\'unique et irremplaçable. Au C.A.C.E, nous estimons que les êtres humains apprennent différemment et à des vitesses différentes mais chaque personne peut réussir sa vie si un accompagnement approprié lui est offert.',
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '#na',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/3_preparation_rentree_scolaire2022_2023/3_preparation_rentree_scolaire2022_2023.jpg',
    galleria: [
      {
        src: 'assets/images/events/3_preparation_rentree_scolaire2022_2023/img/1.jpg',
        caption: 'preparation_rentree_scolaire2022_2023',
        thumb: 'assets/images/events/3_preparation_rentree_scolaire2022_2023/img/1.jpg'
      }
    ]
  },
  {
    id: 4,
    code: 'event_4',
    title: 'Exposition de l\'atelier d\'origami',
    shortDescription: 'Les pensionnaires du C.A.C.E, s\'adonnent à plusieurs activités manuelles et ludiques.',
    description: `Les pensionnaires du <b>C.A.C.E</b>, s\'adonnent à plusieurs activités manuelles et ludiques. Les objets réalisés par les ateliers sont exposés afin de valoriser l\'esprit créatif.`,
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '#na',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/4_exposition_atelier_origami/4_exposition_atelier_origami.jpeg',
    galleria: [
      {
        src: 'assets/images/events/4_exposition_atelier_origami/img/1.jpg',
        caption: 'exposition_atelier_origami_1',
        thumb: 'assets/images/events/4_exposition_atelier_origami/img/1.jpg'
      },
      {
        src: 'assets/images/events/4_exposition_atelier_origami/img/2.jpeg',
        caption: 'exposition_atelier_origami_2',
        thumb: 'assets/images/events/4_exposition_atelier_origami/img/2.jpeg'
      },
      {
        src: 'assets/images/events/4_exposition_atelier_origami/img/3.jpeg',
        caption: 'exposition_atelier_origami_3',
        thumb: 'assets/images/events/4_exposition_atelier_origami/img/3.jpeg'
      }
    ]
  },
  {
    id: 5,
    code: 'event_5',
    title: 'Passation de ceinture',
    shortDescription: 'Au C.A.C.E, nous donnons du sens à l\'affirmation « un esprit sain dans un corps sain » en développant des activités sportives selon les conditions et les étapes de croissance des enfants.',
    description: 'Au <b>C.A.C.E</b>, nous donnons du sens à l\'affirmation « un esprit sain dans un corps sain » en développant des activités sportives selon les conditions et les étapes de croissance des enfants. Le club Taekwondo du C.A.C.E est l\'un des clubs de la section activités physiques et sportives qui fait notre fierté lors des examens et des compétitions.',
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '#na',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/5_passation_ceinture/5_passation_ceinture.jpg',
    galleria: [
      {
        src: 'assets/images/events/5_passation_ceinture/img/1.jpg',
        caption: 'passation_ceinture_1',
        thumb: 'assets/images/events/5_passation_ceinture/img/1.jpg'
      },
      {
        src: 'assets/images/events/5_passation_ceinture/img/2.jpg',
        caption: 'passation_ceinture_2',
        thumb: 'assets/images/events/5_passation_ceinture/img/2.jpg'
      },
      {
        src: 'assets/images/events/5_passation_ceinture/img/3.jpg',
        caption: 'passation_ceinture_3',
        thumb: 'assets/images/events/5_passation_ceinture/img/3.jpg'
      }
    ]
  },
  {
    id: 6,
    code: 'event_6',
    title: 'Découverte de la profession Pilote',
    shortDescription: 'Nous avions reçu au C.A.C.E une hôte de marque. Monsieur Alexandre Quirin VISSOH, Pilote de ligne de profession.',
    description: `Le 9 février 2021, nous avions reçu au C.A.C.E une hôte de marque. Monsieur Alexandre Quirin VISSOH, <b>Pilote de ligne de profession</b>.
     Il a gravi tous les échelons de son domaine jusqu\'au grade de commandant.
      Admis à faire valoir son droit à la retraite, ce digne fils du Bénin est actuellement un instructeur dans les prestigieuses écoles d\'avion dans le monde.
       L\'homme avait passé plus d\'une heure et demie d\'horloge en compagnie de nos pensionnaires.
        Des questions des pensionnaires à notre hôte, en passant par les conseils et le partage, tout y était ce jour-là. Le pilote de ligne a exprimé sa
         disponibilité à orienter et accompagner les enfants qui souhaiteraient évoluer dans le domaine de l\'avion comme lui notamment les filles.
          Vêtu d\'une simple chemise noire, ce digne fils du Bénin est très humble et d\'une générosité exceptionnelle et c\'est pourquoi les pensionnaires lui avaient offert ce tableau en guise de souvenir.
           D\'autres rencontres se préparent encore car nos pensionnaires, vos enfants ont besoin de repères et de modèles de réussite
    `,
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '9 Février 2021',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/6_decouverte_profession_pilote/6_decouverte_profession_pilote.jpg',
    galleria: [
      {
        src: 'assets/images/events/6_decouverte_profession_pilote/img/1.jpg',
        caption: 'decouverte_profession_pilote_1',
        thumb: 'assets/images/events/6_decouverte_profession_pilote/img/1.jpg'
      },
      {
        src: 'assets/images/events/6_decouverte_profession_pilote/img/2.jpg',
        caption: 'decouverte_profession_pilote_2',
        thumb: 'assets/images/events/6_decouverte_profession_pilote/img/2.jpg'
      },
      {
        src: 'assets/images/events/6_decouverte_profession_pilote/img/3.jpg',
        caption: 'decouverte_profession_pilote_3',
        thumb: 'assets/images/events/6_decouverte_profession_pilote/img/3.jpg'
      }
    ]
  },
  {
    id: 7,
    code: 'event_7',
    title: 'Sorties récréatives avec notre partenaire tata Bibi',
    shortDescription: 'La détente, les activités ludiques et récréatives sont indispensables pour l\'équilibre de l\'être humain.',
    description: `La détente, les activités ludiques et récréatives sont indispensables pour l\'équilibre de l\'être humain. Conscient de cette réalité,
     le <b>C.A.C.E</b> en collaboration avec ses partenaires tels que les ateliers 
    de tata Bibi et autres organisent des bons moments de détentes. Prenez le rendez-vous des prochaines sorties récréatives dans quelques jours.`,
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '#na',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/7_sorties_recreatives_partenaire_tata_Bibi.jpg',
    galleria: [
      {
        src: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/img/1.jpg',
        caption: 'sorties_recreatives_avec_tata_Bibi_1',
        thumb: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/img/1.jpg'
      },
      {
        src: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/img/2.jpg',
        caption: 'sorties_recreatives_avec_tata_Bibi_2',
        thumb: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/img/2.jpg'
      },
      {
        src: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/img/3.jpg',
        caption: 'sorties_recreatives_avec_tata_Bibi_3',
        thumb: 'assets/images/events/7_sorties_recreatives_partenaire_tata_Bibi/img/3.jpg'
      }
    ]
  },
  {
    id: 8,
    code: 'event_8',
    title: 'Séance de restitution de fin de CaVALIÉ 2022 avec les parents',
    shortDescription: 'Aucune entité ne peut remplacer les parents que vous êtes pour les enfants.',
    description: 'Aucune entité ne peut remplacer les parents que vous êtes pour les enfants. Au <b>C.A.C.E</b>, nous mesurons la portée de votre précieux rôle du premier éducateur et c\'est pourquoi nous développons une franche collaboration avec vous en organisant avant, pendant et après nos programmes des séances d\'échanges, de partage d\'expériences et de sensibilisation. Chers parents des apprenants, il ne saurait avoir une éducation réussie sans vous. Tous ensemble, œuvrons pour relever les défis de l\'éducation de notre temps.',
    date: '#na',
    hour: '#na',
    category: '#na',
    localisation: '#na',
    meetRoomLink: '#na',
    nextEvent: '#na',
    nextEventDate: '#na',
    nextEventHour: '#na',
    mainBanner: 'assets/images/events/8_seance_restitution_fin_CaVALIE_2022_avec_parents/8_seance_restitution_fin_CaVALIE_2022_avec_parents.jpg',
    galleria: [
      {
        src: 'assets/images/events/8_seance_restitution_fin_CaVALIE_2022_avec_parents/img/1.jpg',
        caption: 'seance_restitution_fin_CaVALIE_2022_avec_parents',
        thumb: 'assets/images/events/8_seance_restitution_fin_CaVALIE_2022_avec_parents/img/1.jpg'
      }
    ]
  }
]